module.exports = __webpack_public_path__ + "static/media/m3tj84.1cc66139.png";